<template>
  <div>
      <div class="card">
        <div class="card-body">
          <h5 class="card-title text-uppercase">
            {{ $t("models.thiSinh.titleCard1") }}
          </h5>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="txtHoTen">1. {{ $t("models.thiSinh.hoTen") }}: {{ thisinh.hoTen }} </label>
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtGioiTinh" class="pr-5"
                >2. {{ $t("models.thiSinh.gioiTinh") }}: {{ thisinh.gioiTinh }}
              </label>
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtNgaySinh"> 3. {{ $t("models.thiSinh.ngaySinh") }}: {{ thisinh.ngaySinh }} </label>
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtGioiTinh" class="pr-5"
                >4. {{ $t("models.thiSinh.noiSinh") }}: {{ thisinh.noiSinh  }}
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="txtCoQuanCongTac"
                >5 {{ $t("models.thiSinh.coQuanCongTac") }}: {{ thisinh.coQuanCongTac }}
              </label>
            </div>
            <div class="col-md-6 mb-3">
              <label for="txtSoNamCongTac">{{ $t("models.thiSinh.soNamCongTac") }}: {{ thisinh.soNamCongTac }} </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="ddlDoiTuong">7 {{ $t("models.thiSinh.doiTuong") }}: {{ thisinh.maDoiTuong }} </label>
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtSoDienThoai"> 8 {{ $t("models.thiSinh.sdt") }}: {{ thisinh.soDienThoai }} </label>
            </div>
            <div class="col-md-6 mb-3">
              <label for="txtEmail">9 {{ $t("models.thiSinh.email") }}: {{ thisinh.email }}</label>
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtSoCMND">10 {{ $t("models.thiSinh.cmnd") }}: {{ thisinh.soCmnd }}</label>
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtNgayCap"> {{ $t("models.thiSinh.ngayCap") }}: {{ thisinh.ngayCap }}</label>
            </div>
            <div class="col-md-6 mb-3">
              <label for="txtNoiCap">10 {{ $t("models.thiSinh.noiCap") }}: {{ thisinh.noiCap }}</label>
            </div>
						<!-- <div class="col-md-12 mb-3">
              <label for="txtFileCmnd">
               File Cmnd/CCCD:
              </label>
							<ul v-html="showNameFile(thisinh.fileCmndTypeFile.length > 0 ? thisinh.fileCmndTypeFile: thisinh.fileCmnd)"></ul>
            </div> -->
            <div class="col-12">
              <label for="fileDinhKemCmnd"> File scan/ảnh CMND/CCCD </label>
              <ul v-html="showNameFile(thisinh.fileDinhKemCmnd)"></ul>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="txtDanToc">11 {{ $t("models.thiSinh.danToc") }}: {{ thisinh.danToc }} </label>
            </div>
            <div class="col-md-8 mb-3">
              <label for="txtHoKhau"> 12 {{ $t("models.thiSinh.diaChi") }}: {{ thisinh.hoKhau }} </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col mb-3">
              <label for="txtHoKhau"> 13 {{ $t("models.thiSinh.dcLienHe") }}: {{ thisinh.diaChi }} </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label for="txtSoBaiBao">
                14 Số bài báo đăng trên tạp chí chuyên ngành hoặc kỷ yếu hội thảo khoa học cấp trường trở lên:
                {{ thisinh.soBaiBao }}
              </label>
							<ul v-html="showNameFile(thisinh.fileBaiBaoTypeFile.length > 0 ? thisinh.fileBaiBaoTypeFile: thisinh.fileBaiBao)"></ul>
            </div>
            <div class="col-md-12 mb-3">
              <label for="txtSoDeTai">
                15 Số đề tài nghiên cứu tham gia hoặc chủ nhiệm Gửi minh chứng quyết định giao nhiệm vụ và biên bản
                nghiệm thu: {{ thisinh.soDeTai }}
              </label>
							<ul v-html="showNameFile(thisinh.fileDeTaiTypeFile.length > 0 ? thisinh.fileDeTaiTypeFile: thisinh.fileDeTai)"></ul>
            </div>
            <div class="col-md-12 mb-3">
              <label for="txtSoDeTai">
                16 Tải minh chứng (Bằng tốt nghiệp, Bảng điểm và các giấy tờ ưu tiên nếu có):
              </label>
							<ul v-html="showNameFile(thisinh.fileMinhChungTypeFile.length > 0 ? thisinh.fileMinhChungTypeFile: thisinh.fileHocBa)"></ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <h5 class="card-title text-uppercase">
            2. Thông tin học tập
          </h5>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <span style="text-decoration: underline;">Tốt nghiệp Đại học (Bằng chính xét tuyển)</span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="txtDaiHocTotNghiep"> Trường:</label>
              <input
                type="text"
                id="txtDaiHocTotNghiep"
                class="form-control"
                v-model="thisinh.daiHocTotNghiep"
                placeholder="Trường"
                readonly
              />
            </div>
            <div class="col-md-4 mb-3">
              <label for="txtNganhTotNghiep"> Ngành: </label>
              <input
                type="text"
                id="txtNganhTotNghiep"
                class="form-control"
                v-model="thisinh.nganhTotNghiep"
                placeholder="Ngành"
                readonly
              />
            </div>
            <div class="col-md-4 mb-3">
              <label for="txtChuyenNganhTotNghiep"> Chuyên ngành:</label>
              <input
                type="text"
                id="txtChuyenNganhTotNghiep"
                class="form-control"
                v-model="thisinh.chuyenNganhTotNghiep"
                placeholder="Chuyên ngành"
                readonly
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="txtHeDaoTao"> Hệ đào tạo: </label>
              <input :id="`cbHeDaoTao`" class="form-control" readonly :value="thisinh.heDaoTaoId | tenHeDaoTao(hedaotaos)" />
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtTGDaoTao"> Thời gian đào tạo (năm): </label>
              <input
                type="number"
                id="txtTGDaoTao"
                class="form-control"
                v-model="thisinh.thoiGianDaoTao"
                placeholder="Thời gian đào tạo (năm)"
                readonly
              />
            </div>
            <div class="col-md-3 mb-3">
              <label for="txtNamTotNghiep"> Năm tốt nghiệp: </label>
              <input
                type="number"
                id="txtNamTotNghiep"
                class="form-control"
                v-model="thisinh.namTotNghiep"
                placeholder="Năm tốt nghiệp"
                readonly
              />
            </div>
            <div class="col-md-3 mb-3">
              <label for="ddXepLoaiTotNghiep"> Xếp loại tốt nhiệp: </label>
              <input id="ddXepLoaiTotNghiep" class="form-control" v-model="thisinh.xepLoaiTotNghiep" readonly />
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <h5 class="card-title text-uppercase">
            3. Thông tin học thạc sĩ
          </h5>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <v-text-field
                :name="$t('models.nguyenVong.coSo')"
                :label="$t('models.nguyenVong.coSo')"
                outlined
                dense
                readonly
                :value="nguyenvong.nganhId | tenCoSo(nganhs, cosoes)"
              >
              </v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8 mb-3">
              <v-text-field
                name="Đăng ký tuyển sinh thạc sĩ ngành"
                label="Đăng ký tuyển sinh thạc sĩ ngành"
                outlined
                dense
                readonly
                :value="nguyenvong.nganhId | maNganh(nganhs)"
              ></v-text-field>
            </div>
            <div class="col-md-4 mb-3">
              <v-text-field
                name="Định hướng"
                label="Định hướng"
                outlined
                dense
                readonly
                :value="nguyenvong.dinhHuong"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <v-text-field
              name="Đăng ký hình thước tuyển"
              label="Đăng ký hình thước tuyển"
              outlined
              dense
              readonly
              :value="nguyenvong.hinhThucTuyen"
            ></v-text-field>
          </div>
					<div class="col-md-12">
						<label for="coSo"> Chứng chỉ ngoại ngữ: </label>
						<ul v-html="showNameFile(nguyenvong.fileDinhKemCcnn)">
						</ul>
					</div>
					<div class="col-md-12">
						<label for="coSo"> Có đăng ký học ôn và thi tiếng anh: {{nguyenvong.hocThiTiengAnh | chooseHocThiTiengAnh}} </label>
					</div>
        </div>
      </div>

      <div class="form-row mt-3">
        <div class="col-3">
          <button id="saveThongTin" class="btn btn-primary form-control" @click="save">
            Nộp hồ sơ
          </button>
        </div>
        <div class="col-3">
          <button id="backEdit" class="btn btn-warning form-control" @click="comeBack('kiem_tra_lai')">
            {{ $t("button.chinhSua") }}
          </button>
        </div>
      </div>
      <dialog-loader ref="dialogLoader"></dialog-loader>
    </div>
</template>

<script>
import ThongTinDangKy from "../js/thongtindangky";
export default ThongTinDangKy;
</script>

<style lang="scss" scoped></style>
